/**
 * @flow
 */
'use strict';

export const santeOcculaire2Codes = [
{"code":"Alternant"},
{"code":"Amblyopie OD"},
{"code":"Avec LC"},
{"code":"Avec lunettes"},
{"code":"Avec ordinateur"},
{"code":"Cat OU"},
{"code":"Chirurgie"},
{"code":"Constant"},
{"code":"Côté G"},
{"code":"Gauche"},
{"code":"Glc OU"},
{"code":"Intermittant"},
{"code":"Le soir"},
{"code":"Longtemps"},
{"code":"Normale"},
{"code":"O.D."},
{"code":"O.G."},
{"code":"O.U."},
{"code":"Pas LA"},
{"code":"Pas chx"},
{"code":"Pas de DMLA"},
{"code":"Pas de GLC"},
{"code":"Pas de douleur"},
{"code":"Pas de douleur, picotement, sécheresse"},
{"code":"Pas de rougeur"},
{"code":"Pas de séch."},
{"code":"Pas de trauma/chx"},
{"code":"Pas diplopie"},
{"code":"Pas douleur"},
{"code":"Pas flashes"},
{"code":"Pas floaters"},
{"code":"Pas glc, DMLA"},
{"code":"Pas larmoiement"},
{"code":"Pas rougeur"},
{"code":"Pas strabisme"},
{"code":"Pas sécheresse"},
{"code":"Pas trauma"},
{"code":"Rare"},
{"code":"Sans Rx"},
{"code":"Sécheresse"},
]
